export const h = {
  system: "中文",
  CompanyProfile: "About us",
  GrowthProcess: "History",
  MainBusiness: "Main business",
  BusinessData: "Our achievements",
  CoreCompetitiveness: "Our edge",
  ContactInformation: "Contact us",
  CompanyName: "Tema Golf",
  Service: "Integrated Golf Service Operator",
  BGT: "Booking & Golf Travel",
  ABE: "Annual booking exceed 700,000 rounds(18 holes)",
  MS: "Membership Sales",
  AGENT: "Sole agent of over 30 golf courses",
  SHM: "Membership Sales &Transaction",
  EO: "Event Organisation",
  HOLCEA: "Holds over 500 large-scale commercial events annually",
  TGPS: "Tema Golf Pro Shop",
  SIC: "25 Shops in China",
  NM: "New Media",
  MCALSR: "Media coverage and live streaming rooms",
  SS: "Specialised Sales",
  PT: "Programmer Team",
  TCC: "3 Call Centers",
  ShenZhen: "ShenZhen",
  BeiJing: "BeiJing",
  ShangHai: "ShangHai",
  TeamAdvantage: "Team edge",
  Customerbase: "Customer base",
  ServiceSystem: "Service system",
  Brand: "Brand",
  TTBGT: "Tee time booking & Golf Travel",
  CACC: "21 years of customer accumulation",
  COGE: "covering over 80% of the golf enthusiasts",
  TemaApp: "Tema App",
  MiniApp: "Mini App",
  NewMedia: "New Media",
  PhysicalStore: "Physical Store",
  SalesTeam: "Sales Team",
  TournamentTeam: "Tournament Team",
  experience: "21 years of deep expertise in golf industry",
  CR: "Customer recognition",
  CV: "Industry recognition",
};
